export type ShipByHeatmapLevel = 0 | 1 | 2 | 3 | 4;

export function maxSerializedUnitsInMonth(
  serializedUnitsByDate: Readonly<Record<string, number>>,
  isoDatesInMonth: readonly string[],
): number {
  let max = 0;
  for (const isoDate of isoDatesInMonth) {
    const units = serializedUnitsByDate[isoDate] ?? 0;
    if (units > max) {
      max = units;
    }
  }
  return max;
}

export function shipByHeatmapLevel(units: number, maxUnits: number): ShipByHeatmapLevel {
  if (units <= 0 || maxUnits <= 0) {
    return 0;
  }
  const ratio = units / maxUnits;
  if (ratio >= 0.85) {
    return 4;
  }
  if (ratio >= 0.6) {
    return 3;
  }
  if (ratio >= 0.35) {
    return 2;
  }
  return 1;
}

export function shipByHeatmapCellClass(level: ShipByHeatmapLevel, options: { selected: boolean }): string {
  if (options.selected) {
    return "";
  }
  switch (level) {
    case 1:
      return "bg-red-50 hover:bg-red-100";
    case 2:
      return "bg-red-100 hover:bg-red-200/70";
    case 3:
      return "bg-red-200/80 hover:bg-red-200";
    case 4:
      return "bg-red-300/90 hover:bg-red-300";
    default:
      return "";
  }
}

/** Diagonal hatch drawn above the heat fill on SGS holiday cells. */
export const SHIP_BY_HOLIDAY_HATCH_CLASS =
  "bg-[repeating-linear-gradient(-45deg,transparent,transparent_2px,rgba(180,83,9,0.22)_2px,rgba(180,83,9,0.22)_4px)]";

export function sumSerializedUnitsForIsoDates(
  isoDates: readonly string[],
  serializedUnitsByDate: Readonly<Record<string, number>>,
): number {
  let total = 0;
  for (const isoDate of isoDates) {
    total += serializedUnitsByDate[isoDate] ?? 0;
  }
  return total;
}

export const SHIP_BY_WEEK_COLUMN_HEADER_HINT = "Serialized units shipping that week";

export const SHIP_BY_WEEK_TOTAL_COLUMN_HINT =
  "Total serialized units with ship-by in this calendar week (all seven days in the row)";

export function shipByDayCellHoverHint(options: {
  isoDate: string;
  dayUnits: number;
  holidayName: string | null;
  formatUsDate: (isoDate: string) => string;
}): string | null {
  const { isoDate, dayUnits, holidayName, formatUsDate } = options;
  if (dayUnits > 0) {
    return `${holidayName ?? formatUsDate(isoDate)} · ${dayUnits} serialized`;
  }
  if (holidayName != null) {
    return holidayName;
  }
  return null;
}
